const cmsCate = () =>
	import ( /* webpackChunkName: "tabbar-home" */ '@/views/cms/cms-cate/cms-cate.vue');
const cms_detail = () =>
  import ( /* webpackChunkName: "Tabbar" */ '@/views/cms/cms-detail/cms-detail.vue');

const moduleType1 = () =>
	import ( /* webpackChunkName: "tabbar-home" */ '@/views/cms/cms-cate/module_type_1.vue');
const moduleType2 = () =>
  import ( /* webpackChunkName: "tabbar-home" */ '@/views/cms/cms-cate/module_type_2.vue');

const moduleType3 = () =>
import ( /* webpackChunkName: "tabbar-home" */ '@/views/cms/cms-cate/module_type_3.vue');

const moduleType4 = () =>
import ( /* webpackChunkName: "tabbar-home" */ '@/views/cms/cms-cate/module_type_4.vue');

export default [
	{
		path: "/cms/:company_id",
		name: "cms_cate",
		components: {
      default: cmsCate
		},
		meta: {
      title:'信息发布',
      hideMenu: true
		}
	}, {
    path: '/cms_detail/:id/:company_id',
    name: "cms_detail",
    components: {
      default: cms_detail
    },
    meta: {
      title:'信息发布',
      hideMenu: true
		}
  },
   {
    path: '/module_type_1',
    name: "module_type_1",
    components: {
      default: moduleType1
    },
    meta: {
      title:'信息发布',
      keepAlive: true,
      hideMenu: true
		}
	},
  {
   path: '/module_type_2',
   name: "module_type_2",
   components: {
     default: moduleType2
   },
   meta: {
     title:'信息发布',
     keepAlive: true,
     hideMenu: true
   }
 },
 {
  path: '/module_type_3',
  name: "module_type_3",
  components: {
    default: moduleType3
  },
  meta: {
    title:'信息发布',
    keepAlive: true,
    hideMenu: true
  }
},
{
 path: '/module_type_4',
 name: "module_type_4",
 components: {
   default: moduleType4
 },
 meta: {
   title:'信息发布',
   keepAlive: true,
   hideMenu: true
 }
}
]
